import { __decorate, __extends } from "tslib";
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import Dropzone from 'react-dropzone-uploader';
import { EndPoints, getAuthHeader, getBaseUrl, getImageUrl, UploadType } from '../../api';
import { createGroup, updateGroup } from '../../api/groups';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';
import S from './products.styl';
var ProductsGroupDetailsModal = /** @class */ (function (_super) {
    __extends(ProductsGroupDetailsModal, _super);
    function ProductsGroupDetailsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            titleInputError: false,
            imageInputError: false,
        };
        _this.dropZoneImage = null;
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'title') {
                _this.setState({ titleInputError: false });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.onClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.getUploadImageParams = function (_) {
            return {
                url: getBaseUrl() + EndPoints.upload + '?type=' + UploadType.group,
                headers: getAuthHeader(),
            };
        };
        _this.handleImageChangeStatus = function (params, status) {
            if (status === 'done') {
                var response = JSON.parse(params.xhr.response);
                _this.setState({
                    attachedImage: response.data.fileName,
                });
                _this.dropZoneImage.files = [];
            }
        };
        return _this;
    }
    ProductsGroupDetailsModal.prototype.componentDidMount = function () {
        if (this.props.editGroup) {
            var editGroup = this.props.editGroup;
            this.setState({
                attachedImage: editGroup.image,
            });
        }
    };
    ProductsGroupDetailsModal.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var title = elements.title.value;
        if (title.length === 0) {
            this.setState({ titleInputError: true });
            valid = false;
        }
        var image = this.state.attachedImage;
        if (!image || image.length === 0) {
            this.setState({ imageInputError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            title: title,
            image: this.state.attachedImage || '',
        };
        this.setState({ loading: true });
        if (this.props.editGroup) {
            request.id = this.props.editGroup.id;
            updateGroup(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
        else {
            createGroup(request).then(function () {
                _this.setState({ loading: false });
                _this.isUpdated();
            }).catch(function (error) {
                _this.setState({ loading: false });
                alert(error);
            });
        }
    };
    ProductsGroupDetailsModal.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        var editGroup = this.props.editGroup;
        var i18n = props.store.i18n;
        var loading = state.loading;
        return (React.createElement(Modal, { className: props.className, onRequestClose: props.onClose },
            React.createElement("div", { className: S.productsAddView },
                React.createElement("p", { className: S.productsHeaderText }, editGroup ?
                    i18n.productsGroupUpdateTitle
                    :
                        i18n.productsGroupCreateTitle),
                React.createElement("form", { className: "" + S.detailsDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                    React.createElement("div", null,
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.inputTitlePlaceholder),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "title", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: editGroup === null || editGroup === void 0 ? void 0 : editGroup.title })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.titleInputError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                        React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleIcon),
                        React.createElement("div", { className: "formUploadWrapper" },
                            state.attachedImage ?
                                React.createElement("img", { className: "preview", src: getImageUrl(state.attachedImage) })
                                :
                                    '',
                            React.createElement(Dropzone, { ref: function (r) { return _this.dropZoneImage = r; }, getUploadParams: this.getUploadImageParams, onChangeStatus: this.handleImageChangeStatus, multiple: false, inputContent: i18n.inputUploaderPlaceholder, canRestart: true, canCancel: false, canRemove: false, accept: "image/*" })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.imageInputError ? 'inputErrorActive' : '') }, i18n.validationImageError)),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.productsModalButton, type: "submit", spinner: loading }, editGroup ?
                        i18n.actionUpdate
                        :
                            i18n.actionCreate),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.productsModalButton + " " + S.productsModalCancel, type: "button", spinner: loading, onClick: this.onClose }, i18n.alertModalCancel)))));
    };
    __decorate([
        action.bound
    ], ProductsGroupDetailsModal.prototype, "onSubmit", null);
    ProductsGroupDetailsModal = __decorate([
        inject('store'),
        observer
    ], ProductsGroupDetailsModal);
    return ProductsGroupDetailsModal;
}(React.Component));
export { ProductsGroupDetailsModal };
